module.exports = __webpack_public_path__ + "img/add-p.4406f7a5.svg";